/**
 * @file Gravity Forms customization.
 */

// import { gsap } from 'gsap';

/**
 * Gravity Form component.
 */
const vGravityForms = () => {
	const { gform } = window;

	if (!gform || !window.jQuery) {
		return;
	}

	const handleFormLabels = () => {
		const fields = document.querySelectorAll(
			`.gfield--type-text, .gfield--type-phone, .gfield--type-email, .gfield--type-website, .gfield--type-number, .gform-grid-col[class*='address_']`,
		);

		[...fields].forEach((f) => {
			const field = f.querySelector('input') || f.querySelector('select');

			if (!field) {
				return;
			}

			const label = f.querySelector('label');

			// If field is focused animate the label
			['focus', 'change'].forEach((event) => {
				field.addEventListener(event, () => {
					if (!label.classList.contains('float-up') && !f.classList.contains('ginput_address_country')) {
						label.classList.add('float-up');
					}
				});
			});

			// If field is blurred & does not have a value, animate the label
			field.addEventListener('blur', () => {
				if (!field.value.trim() && label.classList.contains('float-up')) {
					label.classList.remove('float-up');
				}
			});

			// on load, if field has a value, animate the label
			if (field.value.trim() && !label.classList.contains('float-up') && !f.classList.contains('ginput_address_country')) {
				label.classList.add('float-up');
			}
		});
	};

	window.jQuery(document).on('gform_post_render', () => {
		handleFormLabels();

		const fileUpload = document.querySelector(
			'.gfield--type-fileupload input[type="file"]',
		);

		if (fileUpload) {
			const parent = fileUpload.parentElement;

			const resetButton = document.createElement('button');
			resetButton.classList.add(
				'v-form__file-reset',
				'v-form__file-reset--hidden',
			);
			resetButton.innerHTML = 'Remove';
			resetButton.setAttribute('type', 'button');
			resetButton.addEventListener('click', () => {
				fileUpload.value = '';
				parent.style.removeProperty('--v-upload-button-text');
				parent.classList.remove('file-selected');
				resetButton.classList.add('v-form__file-reset--hidden');
			});
			parent.insertBefore(resetButton, fileUpload.nextSibling);

			const inputLabel = document.createElement('label');
			inputLabel.classList.add('v-form__file-fake-button');
			inputLabel.setAttribute('for', fileUpload.id);
			parent.insertBefore(inputLabel, fileUpload.nextSibling);

			fileUpload.addEventListener('change', () => {
				const fileName = fileUpload.files[0]?.name || 'Upload File';

				// set parent's custom property to the file name
				parent.style.setProperty('--v-upload-button-text', `'${fileName}'`);
				parent.classList.add('file-selected');

				if (fileUpload.files.length) {
					resetButton.classList.remove('v-form__file-reset--hidden');
				} else {
					resetButton.classList.add('v-form__file-reset--hidden');
				}
			});
		}

	/*
	|
	| Animate labels of regular fields
	|
	*/
	// fields.forEach((el) => {
	// 	const label = el.querySelector('label');
	// 	const input = el.querySelector('input');
	// 	const initialHeight = 5;
	// 	const clickedHeight = -20;

	// 	gsap.set(label, {
	// 		y: initialHeight,
	// 	});

	// 	input.addEventListener('focus', () => {
	// 		// Set labels back to initial position only if their corresponding inputs are empty
	// 		fields.forEach((field) => {
	// 			const otherLabel = field.querySelector('label');
	// 			const otherInput = field.querySelector('input');
	// 			if (otherInput.value.trim() === '') {
	// 				gsap.to(otherLabel, {
	// 					y: initialHeight,
	// 					duration: 0.2,
	// 				});
	// 			}
	// 		});

	// 		// Animate only the clicked field's label
	// 		gsap.to(label, {
	// 			y: clickedHeight,
	// 			duration: 0.2,
	// 		});
	// 	});

	// 	input.addEventListener('input', () => {
	// 		// Keep the label on top if input is not empty
	// 		if (input.value.trim() !== '') {
	// 			gsap.to(label, {
	// 				y: clickedHeight,
	// 				duration: 0.2,
	// 			});
	// 		}
	// 	});

	// 	// Reset the label when input loses focus only if the input is empty
	// 	input.addEventListener('blur', () => {
	// 		if (input.value.trim() === '') {
	// 			gsap.to(label, {
	// 				y: initialHeight,
	// 				duration: 0.2,
	// 			});
	// 		}
	// 	});

	// 	// Check on load and adjust label position if input is filled
	// 	console.log(input.value.trim());
	// 	if (input.value.trim() !== '') {
	// 		gsap.to(label, {
	// 			y: clickedHeight,
	// 			duration: 0.2,
	// 		});
	// 	}
	// });

	/*
	|
	| Animate labels of address fields
	|
	*/
	// addressWrapper.forEach((el) => {
	// 	const label = el.querySelector('label');
	// 	const input = el.querySelector('input');
	// 	const initialHeight = -33;
	// 	const clickedHeight = -60;

	// 	gsap.set(label, {
	// 		y: initialHeight,
	// 	});

	// 	input.addEventListener('focus', () => {
	// 		// Set labels back to initial position only if their corresponding inputs are empty
	// 		addressWrapper.forEach((field) => {
	// 			const otherLabel = field.querySelector('label');
	// 			const otherInput = field.querySelector('input');
	// 			if (otherInput.value.trim() === '') {
	// 				gsap.to(otherLabel, {
	// 					y: initialHeight,
	// 					duration: 0.2,
	// 				});
	// 			}
	// 		});

	// 		// Animate only the clicked field's label
	// 		gsap.to(label, {
	// 			y: clickedHeight,
	// 			duration: 0.2,
	// 		});
	// 	});

	// 	input.addEventListener('input', () => {
	// 		// Keep the label on top if input is not empty
	// 		if (input.value.trim() !== '') {
	// 			gsap.to(label, {
	// 				y: clickedHeight,
	// 				duration: 0.2,
	// 			});
	// 		}
	// 	});

	// 	// Reset the label when input loses focus only if the input is empty
	// 	input.addEventListener('blur', () => {
	// 		if (input.value.trim() === '') {
	// 			gsap.to(label, {
	// 				y: initialHeight,
	// 				duration: 0.2,
	// 			});
	// 		}
	// 	});

	// 	// Check on load and adjust label position if input is filled
	// 	if (input.value.trim() !== '') {
	// 		gsap.to(label, {
	// 			y: clickedHeight,
	// 			duration: 0.2,
	// 		});
	// 	}
	// });

	/*
	|
	| Set label of address' country select field
	|
	*/
	// addressWrapperCountry.forEach((el) => {
	// 	const label = el.querySelector('label');
	// 	const select = el.querySelector('select');
	// 	const initialPositionY = -40;
	// 	const raisedPositionY = -60; // Adjust this value as needed for the raised position

	// 	gsap.set(label, {
	// 		y: initialPositionY,
	// 		width: 'fit-content', // so it can still be clicked
	// 	});

	// 	// Event listener for change on the select to handle user selections
	// 	select.addEventListener('change', () => {
	// 		if (select.value) {
	// 			// If a selection has been made
	// 			gsap.to(label, {
	// 				y: raisedPositionY,
	// 				duration: 0.2,
	// 			});
	// 		} else {
	// 			// If the selection is cleared or reset to default with no value
	// 			gsap.to(label, {
	// 				y: initialPositionY,
	// 				duration: 0.2,
	// 			});
	// 		}
	// 	});

	// 	// Check if the select field has a value on page load/refresh
	// 	if (select.value) {
	// 		gsap.to(label, {
	// 			y: raisedPositionY,
	// 			duration: 0.2,
	// 		});
	// 	}
	// });

	/**
	 * Add required labels to address fields if set to required
	*/
	const addRequiredLabelsToAddress = () => {
		const requiredAddressSet = document.querySelector('.gfield--type-address.gfield--input-type-address.gfield_contains_required');

		if(requiredAddressSet === null) {
			return;
		}

		const labels = requiredAddressSet.querySelectorAll('span:not(.address_line_2) .gform-field-label');
		labels.forEach(label => {
			const requiredLabel = '<span class="gfield_required"><span class="gfield_required gfield_required_text">&nbsp;&nbsp;(Required)</span></span>';
			label.innerHTML += requiredLabel;
		});
	};
	addRequiredLabelsToAddress();


	/*
	|
	| Create top section wrapper for Job Application Form
	|
	*/
	// Select the elements
	const topBlockText = document.querySelector(
		'.v-form-job-application__top-block-text',
	);
	const uploadResumeButton = document.querySelector(
		'.v-form__job-application-upload-resume-button',
	);

	// Check if both elements exist on job app form
	if (topBlockText && uploadResumeButton) {
		// Create the wrapper div and add the class
		const wrapperDiv = document.createElement('div');
		wrapperDiv.classList.add('v-form-job-application__top-wrapper');

		// Insert the wrapper before the first element
		topBlockText.parentNode.insertBefore(wrapperDiv, topBlockText);

		// Move both elements into the wrapper
		wrapperDiv.appendChild(topBlockText);
		wrapperDiv.appendChild(uploadResumeButton);

		// New code to wrap other .gfield elements
		const gfields = document.querySelectorAll(
			'.gfield:not(.v-form-job-application__top-block-text.gfield):not(.v-form__job-application-upload-resume-button.gfield)',
		);

		if (gfields.length > 0) {
			const bottomWrapperDiv = document.createElement('div');
			bottomWrapperDiv.classList.add('v-form-job-application__bottom-wrapper');

			// Assuming the first gfield has a parent where we can insert the bottomWrapperDiv
			gfields[0].parentNode.insertBefore(bottomWrapperDiv, gfields[0]);

			gfields.forEach((gfield) => {
				bottomWrapperDiv.appendChild(gfield);
			});
		}
	}
	});


	// Job application form
	gform.addFilter( 'gform_datepicker_options_pre_init', ( optionsObj, formId ) => {
		if ( formId == 6 ) {
			optionsObj.minDate = 0;
		}

		if ( formId == 8 || formId == 7 ) {
			optionsObj.maxDate = 0;
		}
		return optionsObj;
	});
};

export default vGravityForms;
